import { translate as t } from "./locale";
import type { AuthenticatedSession } from "./session";
import { PanelHeader, TRAINER_PANEL_TITLE } from "./editor-shell";
import { StudentLoginForm } from "./student-login";

export const TrainerAccessFrame = ({
    loginError,
    mode,
    onLogin,
}: {
    loginError?: string;
    mode: "checking" | "invalid" | "login";
    onLogin: (session: AuthenticatedSession) => void;
}) => (
    <main className="trainer-access-page">
        <section className="trainer-access-frame" aria-live="polite">
            <PanelHeader title={TRAINER_PANEL_TITLE} />
            <div className="application-card trainer-access-card">
                <div className="trainer-access-notice">
                    <h2>{t("Dostęp dla trenera")}</h2>
                    {mode === "checking" && <p>{t("Sprawdzanie sesji trenera…")}</p>}
                    {mode === "invalid" && (
                        <p className="form-error" role="alert">
                            {t("Link trenera jest nieprawidłowy lub wygasł")}</p>
                    )}
                    {mode === "login" && (
                        <p>{t("Do edycji udostępnionego projektu wymagane jest konto trenera.")}</p>
                    )}
                </div>
                {mode === "login" && (
                    <>
                        {loginError && <p className="form-error" role="alert">{loginError}</p>}
                        <StudentLoginForm
                            codeLabel="Kod trenera"
                            disabled={false}
                            formLabel="Logowanie trenera"
                            onLogin={onLogin}
                        />
                    </>
                )}
            </div>
        </section>
    </main>
);
